module.exports = __webpack_public_path__ + "static/media/SHSProdIcons_Harddrive.715a6903.svg";


//////////////////
// WEBPACK FOOTER
// ./packages/smart-home-support/pages/homepage/resources/SHSProdIcons_Harddrive.svg
// module id = 3547
// module chunks = 0